/** @format */
import { MarketCode } from '@toucan/client/global/market';

// Convert consolidated Intercom workspaces from old market to the EU market
const mappedMarkets: Partial<Record<MarketCode, MarketCode>> = {
    [MarketCode.FR_FR]: MarketCode.EN_EU,
    [MarketCode.FR_BE]: MarketCode.EN_EU,
};

export function getMappedIntercomMarket(market: MarketCode) {
    return mappedMarkets[market] ?? market;
}
